// app/javascript/controllers/p2p/phone_mask_controller.js
//
// Stimulus-контроллер для автоформатирования номера телефона.
// Отображает: +7 999 123 45 67
// При отправке формы: +79991234567 (без пробелов)
//
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.inputEl = this.element
    this.inputEl.addEventListener("input", this._onInput)
    this.inputEl.addEventListener("focus", this._onFocus)

    this.form = this.inputEl.closest("form")
    if (this.form) {
      this.form.addEventListener("submit", this._onSubmit)
    }
  }

  disconnect() {
    this.inputEl.removeEventListener("input", this._onInput)
    this.inputEl.removeEventListener("focus", this._onFocus)
    if (this.form) {
      this.form.removeEventListener("submit", this._onSubmit)
    }
  }

  // Если поле пустое при фокусе — подставляем +7
  _onFocus = (_e) => {
    if (!this.inputEl.value.trim()) {
      this.inputEl.value = "+7 "
    }
  }

  // Форматирование: +7 XXX XXX XX XX
  _onInput = (_e) => {
    const el = this.inputEl
    let raw = el.value.replace(/[^\d+]/g, "")

    // Если начинается с 8 → заменяем на +7
    if (raw.startsWith("8") && raw.length > 1) {
      raw = "+7" + raw.slice(1)
    }
    // Если начинается с 7 без + → добавляем +
    if (raw.startsWith("7") && !raw.startsWith("+")) {
      raw = "+" + raw
    }
    // Если нет + вообще → добавляем +7
    if (!raw.startsWith("+")) {
      raw = "+7" + raw
    }

    // Убираем + для форматирования, потом вставим обратно
    const digits = raw.replace(/\D/g, "") // "79991234567"
    let formatted = "+"

    for (let i = 0; i < digits.length && i < 11; i++) {
      if (i === 1) formatted += " " // +7 _
      if (i === 4) formatted += " " // +7 999 _
      if (i === 7) formatted += " " // +7 999 123 _
      if (i === 9) formatted += " " // +7 999 123 45 _
      formatted += digits[i]
    }

    el.value = formatted
  }

  // Перед submit — убираем пробелы
  _onSubmit = (_e) => {
    this.inputEl.value = this.inputEl.value.replace(/[\s\-\(\)]/g, "")
  }
}
